module.exports = __webpack_public_path__ + "img/worksbot_img20022509.ca0d398a.jpg";